// pages/HomePage.js
import React from 'react';
import Home from '../components/HomePage/Home';
import About from '../components/HomePage/About';
// import Services from '../components/HomePage/Services';
import Services from '../components/ServicesPage/HomeServiceComponent';
import Contact from '../components/HomePage/Contact';
import Footer from '../components/Footer';


function HomePage() {
  return (
    <div>
      <Home />
      <About/>
      <Services/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default HomePage;
